export { default } from './ImageMapperContainer';
